export const checkAmountWithDollarSign = (amount: string) => !!Number(amount.replace('$', '').replaceAll(',', ''));
